'use client';

import { useEffect } from 'react';
import { type Decisions } from '../types';
import { createInstance } from '@optimizely/optimizely-sdk';
import { getENV } from '../utils';
import Cookie from 'js-cookie';

export const useOriginalOptimizely = (flag: keyof Decisions) => {
    const optimizely = createInstance({
        // logLevel: 4,
        sdkKey: getENV('NEXT_PUBLIC_OPTIMIZELY_SDK_KEY'),
    });

    const host = window.location.hostname;
    const attributes = {
        Domain: host,
    };
    const userId = Cookie.get('x-petm-visitor-id');
    useEffect(() => {
        optimizely?.onReady().then(() => {
            optimizely?.createUserContext(userId, attributes)?.decide(flag);
        });
    }, [optimizely]);

    return optimizely?.createUserContext(userId, attributes);
};
